import{classAdderBuilder as s}from"../../common/dist/classadder/classAdderBuilder.js";s({class:"mdc-deprecated-list-item__primary-text",tag:"span"});
//# sourceMappingURL=PrimaryText.js.map
